import Input from './Input';

export type {
  InputCssVars,
  InputProps,
  InputRef,
  InputTextareaProps,
  InputTextProps,
} from './Input';

export default Input;
